import { render, staticRenderFns } from "./SignicatSettings.vue?vue&type=template&id=345988b2"
import script from "./SignicatSettings.vue?vue&type=script&lang=js"
export * from "./SignicatSettings.vue?vue&type=script&lang=js"
import style0 from "./SignicatSettings.vue?vue&type=style&index=0&id=345988b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports